import { submitForm } from '@/shared/api/submit';

export const saveCarType = (id: number | undefined, name: string) =>
  submitForm(id ? '/car/type/edit/' : '/car/type/create/', { id, name });

export const saveCarTag = (id: number | undefined, title: string) =>
  submitForm(id ? '/car/tag/edit/' : '/car/tag/create/', { id, title });
